/*eslint no-undef: 0*/

import { getUserAgent } from "../Utils/userAgent";

/**
 * Check if we are in a browser environment (not SSR or Node).
 */
export function hasBrowserEnv() {
  return typeof window !== 'undefined' && typeof navigator !== 'undefined';
}

/**
 * Detect if the current device is a mobile phone.
 */
export function isMobile() {
  if (!hasBrowserEnv()) return false;

  const user_agent = getUserAgent(true);
  const is_mobile_user_agent = /android|iphone|ipod|iemobile|blackberry|bada\/|tizen|mobile|pwa|webos/.test(user_agent);

  if (is_mobile_user_agent) return true;

  // Consider mobile if the viewport width is below 768px
  return matchMediaQuery('(max-width: 767px)');
}

/**
 * Detect if the current device is a tablet.
 */
export function isTablet() {
  if (!hasBrowserEnv()) return false;
  const user_agent = getUserAgent(true);
  const is_tablet_user_agent = /ipad|tablet|kindle|silk|(android(?!.*mobile))/.test(user_agent);

  if (is_tablet_user_agent) return true;

  // Consider tablet if viewport width is between 768px and 1024px
  return matchMediaQuery('dth: 768px) and (max-width: 1024px)');
}

/**
 * Detect if the current device is a desktop.
 */
export function isDesktop() {
  return !isMobile() && !isTablet();
}

/**
 * Check if media querie has match with device
 */
function matchMediaQuery(query) {
  return typeof window !== 'undefined' && window.matchMedia(query).matches;
}